import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import DataTable from './DataTable';
const Page = () => {

  return (
    <Panel
    // header={
    //   <>
    //   <div className='productcrumb'>
    //     <h3 className="title ">All Products</h3>
    //     <Breadcrumb>
    //       <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
    //       <Breadcrumb.Item>Product</Breadcrumb.Item>
    //       {/* <Breadcrumb.Item active>Members</Breadcrumb.Item> */}
    //     </Breadcrumb>
    //     </div>
    //   </>
    // }
    >
      <DataTable />
    </Panel>
  );
};

export default Page;
